module.exports = __webpack_public_path__ + "img/c0827c8605516a8d5a85f663848ddf17.svg";